module.exports = __webpack_public_path__ + "static/media/logo.0fbd1631.png";